import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import LegacySystemSettings from "./LegacySystemSettings.jsx";
import WellnessSettings from "./WellnessSettings.jsx";
import IntegrationSettings from "./IntegrationSettings.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import EnvironmentSettings from "./EnvironmentSettings.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import LightCtrlSettings from "./LightCtrlSettings.jsx";
import SystemSettings from "./SystemSettings.jsx";
import PalPendantSettings from "./PalPendantSettings.jsx";
import Careflow from "./Careflow.jsx";
import TestPage from "./TestPage.jsx";
import StringBuilder from "./StringBuilder.jsx";
import Shifts from "@/components/Shifts.jsx";

const Settings = (props) => {
    let settingsContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);

        dData = JSON.parse(bData.toString(enc.Utf8));
    }
    if (paramVars.dType === "system" && (compareRole("admin", dData?.userrole) || iAmHigherAuthority(20, dData.role_weight))){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            settingsContent = <SystemSettings />;
        }else{
            settingsContent = <LegacySystemSettings />;
        }
    }else if (paramVars.dType === "wellness" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <WellnessSettings />;
    }else if (paramVars.dType === "careflow" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <Careflow />;
    }else if (paramVars.dType === "test" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <TestPage />;
    }else if (paramVars.dType === "text_builder" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <StringBuilder />;
    }else if (paramVars.dType === "environmental" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <EnvironmentSettings />;
    }else if (paramVars.dType === "lightctrl" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <LightCtrlSettings />;
    }else if (paramVars.dType === "palpendant" && dData?.campusData[dData?.acnt.toString()]?.is_cloud && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <PalPendantSettings />;
    }else if (paramVars.dType === "shifts" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <Shifts />;
    }else{
        settingsContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return (compareRole("admin", dData?.userrole) || iAmHigherAuthority(20, dData.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {settingsContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Settings;